import { RegisteredComponent } from "@builder.io/sdk-react";
import { THEME_FIELD } from "../../commonFields";

export const tableBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Table",
  noWrap: true,
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/huihon_iconfont/table-30.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  childRequirements: {
    component: "Table Row",
    message: "Table can only have Table Row components as children!",
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Row",
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Row",
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Row",
      },
    },
  ],
  inputs: [
    {
      name: "ariaLabel",
      type: "string",
      localized: true,
      required: true,
      helperText: "Caption for screen readers describing the table",
    },
    THEME_FIELD,
    {
      name: "variant",
      type: "enum",
      required: false,
      localized: false,
      defaultValue: "regular",
      enum: [
        {
          label: "Regular",
          value: "regular",
        },
        {
          label: "Lined",
          value: "lined",
        },
      ],
    },
    {
      name: "externalSource",
      type: "string",
      enum: ["Product Checksums"],
      helperText: "Select the external source for the table data",
    },
  ],
  defaultStyles: {
    width: "100%",
  },
};
